import { useNavigate } from "react-router-dom";
import "./login.css";
import { useAuthContext } from "../../context/AuthContext";
import { useState } from "react";
import { setToken } from "../../helpers/authHelpers";
import axios from "axios";

export default function Login({ setLoggedUser }) {
  const navigate = useNavigate();
  const { setUser } = useAuthContext();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const onFinish = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    const email = e.target.email.value;
    const password = e.target.password.value;

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/local`,
        {
          identifier: email,
          password: password,
        }
      );

      const data = response.data;

      if (data?.jwt && data?.user) {
        setToken(data.jwt);
        setUser(data.user);
        navigate("/profile", { replace: true });
      } else {
        setError("Login failed. Please check your credentials.");
      }
    } catch (err) {
      // Try to get Strapi's detailed error message
      const message =
        err.response?.data?.error?.message ||
        err.response?.data?.message ||
        "Invalid email or password.";
      setError(message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login">
      <span className="loginTitle">Login</span>

      <form className="loginForm" onSubmit={onFinish} autoComplete="off">
        <label htmlFor="loginEmail">Email</label>
        <input
          name="email"
          id="loginEmail"
          className="loginInput"
          type="email"
          placeholder="Enter your email..."
          required
        />

        <label htmlFor="passInput">Password</label>
        <input
          name="password"
          id="passInput"
          className="loginInput"
          type="password"
          placeholder="Enter your password..."
          required
        />

        {error && (
          <div
            className="loginError"
            style={{ color: "red", marginTop: "10px" }}
          >
            {error}
          </div>
        )}

        <div className="d-flex flex-column gap-2">
          <button type="submit" className="loginButton" disabled={isLoading}>
            {isLoading ? "Logging in..." : "Login"}
          </button>
          <p>If no account, then Register</p>
          <button type="button" className="loginRegisterButton">
            Register
          </button>
        </div>
      </form>
    </div>
  );
}
